webpackJsonp([1],{

/***/ "0JLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ "0aiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loading_vue__ = __webpack_require__("KgXo");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var lineEndOptions = Array.apply(null, Array(9)).map(function (item, i) {
  return i + 2;
});

var that = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    that = this;
    return {
      auth: false,
      loading: false,
      selectOptions: ['单选题', '多选题', '下拉列表', '线性量表', '矩阵量表', '优先级', '文本题'],
      langCode: ['cn', 'en', 'kr', 'jp', 'fr', 'de', 'ru', 'sp', 'po', 'it', 'nl', 'id', 'tr', 'thai', 'zh', 'fa', 'ro', 'ar'],
      langList: ['中文', '英语', '韩语', '日语', '法语', '德语', '俄语', '西班牙语', '葡萄牙语', '意大利语', '荷兰语', '印度语', '土耳其语', '泰语', '繁体中文', '波斯语', '罗马尼亚语', '阿拉伯语'],
      defaultLang: '英语',
      tabLang: '中文',
      editableTabs: ['中文'],
      addLangVisible: false,
      defaultOption: '单选题',
      addRadio: '添加选项',
      lineOptions: [0, 1],
      lineEndOptions: lineEndOptions,
      langArray: [],
      data: {
        display_name: '',
        name: [{
          questionnaire_name: '',
          desc: '',
          language: 'cn'
        }],
        repeat_submit: false,
        question: [{
          question_id: 1,
          types: '单选题',
          is_required: false,
          content: [{
            language: 'cn',
            title: '',
            answer: [{
              answer_id: 1,
              description: '选项1'
            }],
            line_answer: {
              line_value: 1,
              line_end_value: 5,
              line_tag: '',
              line_end_tag: ''
            },
            text_answer: ''
          }] }]
      },
      editable: true,
      focusIndex: 0
    };
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_2__components_loading_vue__["a" /* default */]
  },
  methods: {
    onEnd: function onEnd() {
      that.drag = false;
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedIndex = relatedContext.index;
      var index = draggedContext.index;
      relatedContext.element.question_id = index + 1;
      draggedContext.element.question_id = relatedIndex + 1;
    },
    focusTitle: function focusTitle(event) {
      var classList = event.target.classList;
      if (classList.contains('add-list') || classList.contains('el-icon-plus')) return;
      that.focusIndex = 'title';
    },
    focusItem: function focusItem(event, i) {
      var classList = event.target.classList;
      if (classList.contains('el-icon-delete') || classList.contains('icon-copy') || that.focusIndex === i) return;
      that.focusIndex = i;
    },
    addRadioFn: function addRadioFn(i, j) {
      var list = that.data.question[i].content[j].answer;
      that.addFormFn(list);
    },
    deleteRadioFn: function deleteRadioFn(i, j, k) {
      that.data.question[i].content[j].answer.splice(k, 1);
    },
    addFormFn: function addFormFn(list) {
      var index = list.length ? parseInt(list[list.length - 1].description.substr(2)) + 1 : '1';
      var text = index ? '选项' + index : '选项1';
      list.push({ answer_id: list.length + 1, description: text });
      that.$nextTick(function () {
        var input = document.querySelectorAll('.radio-input');
        input[input.length - 1].focus();
      });
    },
    copyListFn: function copyListFn(index) {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.data.question[index]));
      that.data.question.splice(index, 0, data);
      that.focusIndex = that.data.question.length - 1;
    },
    addListFn: function addListFn() {
      var codeList = that.editableTabs.map(function (i) {
        return that.langCode[that.langList.indexOf(i)];
      });
      var contentList = codeList.map(function (i) {
        return {
          language: i,
          title: '',
          answer: [{
            answer_id: 1,
            description: '选项1'
          }],
          line_answer: {
            line_value: 1,
            line_end_value: 5,
            line_tag: '',
            line_end_tag: ''
          },
          text_answer: ''
        };
      });
      var list = {
        question_id: that.data.question.length + 1,
        types: '单选题',
        is_required: false,
        content: contentList
      };
      that.data.question.push(list);
      that.focusIndex = that.data.question.length - 1;
    },
    deleteListFn: function deleteListFn(i) {
      that.data.question.splice(i, 1);
      that.focusIndex = i === 0 && that.data.question.length > 0 ? i : i - 1;
    },
    saveFn: function saveFn() {},
    addLangFn: function addLangFn() {
      var value = that.defaultLang;
      if (that.editableTabs.indexOf(value) > -1) {
        this.$message({
          type: 'warning',
          message: '语言：' + value + '已经添加过了，请检查一下哦！'
        });
      } else {
        that.editableTabs.push(value);
        that.tabLang = value;
        that.addLangDataFn(value);
      }
      that.addLangVisible = false;
    },
    addLangDataFn: function addLangDataFn(value) {
      var code = that.langCode[that.langList.indexOf(value)];
      that.data.question.map(function (i) {
        var li = {
          language: code,
          title: '',
          answer: [{
            answer_id: 1,
            description: '选项1'
          }],
          line_answer: {
            line_value: 1,
            line_end_value: 5,
            line_tag: '',
            line_end_tag: ''
          },
          text_answer: ''
        };
        i.content.push(li);
        return i;
      });
      that.data.name.push({
        questionnaire_name: '',
        desc: '',
        language: code
      });
    },
    handleTabsEdit: function handleTabsEdit(targetName, action) {
      if (action === 'add') {
        that.addLangVisible = true;
      }
      if (action === 'remove') {
        that.$confirm('确定删除语言: ' + targetName + '的问卷吗？', {
          title: ' ',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          beforeClose: function beforeClose(action, instance, done) {
            var closeFn = function closeFn() {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = '确定';
            };
            if (action === 'confirm') {
              var tabs = that.editableTabs;
              var activeName = that.tabLang;
              if (activeName === targetName) {
                tabs.forEach(function (tab, index) {
                  if (tab === targetName) {
                    var nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                      activeName = nextTab;
                    }
                  }
                });
              }
              that.tabLang = activeName;
              that.editableTabs = tabs.filter(function (tab) {
                return tab !== targetName;
              });
              closeFn();
              done();
            } else {
              closeFn();
              done();
            }
          }
        }).then(function () {}).catch(function () {});
      }
    }
  }
});

/***/ }),

/***/ "3kbv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AFlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__ = __webpack_require__("0aiX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6221b2e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__ = __webpack_require__("zMSr");
function injectStyle (ssrContext) {
  __webpack_require__("ogId")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6221b2e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KgXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("0JLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212f041a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("sbq2");
function injectStyle (ssrContext) {
  __webpack_require__("3kbv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-212f041a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212f041a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lwur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 添加实例方法，挂载到 vue.prototype 上

var plugins = {};
plugins.install = function (Vue, options) {
  // textarea 根据输入内容实现高度自适应
  Vue.prototype.$autoText = function (event) {
    var elem = event.target;
    var height = void 0,
        minHeight = void 0;
    var padding = 0;
    var style = elem.style;
    var getStyle = function getStyle(name) {
      return getComputedStyle(elem, null)[name];
    };
    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;
    padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
    minHeight = parseFloat(getStyle('height'));
    elem.style.height = minHeight + 'px';
    if (elem.scrollHeight > minHeight) {
      height = elem.scrollHeight - padding;
      style.overflowY = 'hidden';
      style.height = height + 'px';
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (plugins);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68aeb38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("dnl9");
function injectStyle (ssrContext) {
  __webpack_require__("W3bc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68aeb38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_index_css__ = __webpack_require__("h2zT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin_index__ = __webpack_require__("Lwur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_iconfont_iconfont_js__ = __webpack_require__("f8sx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_iconfont_iconfont_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_iconfont_iconfont_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__plugin_index__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Switch"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["TabPane"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["TabPane"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_4_element_ui__["MessageBox"].confirm;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__assets_iconfont_iconfont_js___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "W3bc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dnl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    staticClass: "github-corner",
    attrs: {
      "href": "https://github.com/luyilin/vue-google-form",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 250 250"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
    }
  }), _c('path', {
    staticClass: "octo-arm",
    staticStyle: {
      "transform-origin": "130px 106px"
    },
    attrs: {
      "d": "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
      "fill": "currentColor"
    }
  }), _c('path', {
    staticClass: "octo-body",
    attrs: {
      "d": "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('create')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f8sx":
/***/ (function(module, exports) {

(function (window) {
  var svgSprite = '<svg><symbol id="icon-tuozhuai" viewBox="0 0 1039 1024"><path d="M104 468.16a103.936 103.936 0 0 0 0-207.936 103.936 103.936 0 1 0 0 207.936z m0 363.84a103.936 103.936 0 0 0 0-207.872 103.936 103.936 0 1 0 0 207.872z m415.744-363.84a104 104 0 0 0 0-207.936 104 104 0 1 0 0 207.936z m0 363.84a104 104 0 0 0 0-207.872 104 104 0 1 0 0 207.872z m415.68-363.84a104 104 0 0 0 0.128-207.936h-0.128a103.936 103.936 0 0 0 0 207.936z m0 363.84a103.936 103.936 0 0 0 0.128-207.872h-0.128a103.936 103.936 0 0 0 0 207.872z"  ></path></symbol><symbol id="icon-copy" viewBox="0 0 1024 1024"><path d="M729.6 0H148.48C94.72 0 51.2 40.96 51.2 92.16v652.8h97.28V92.16h581.12V0z m145.92 186.88H343.04c-53.76 0-97.28 40.96-97.28 92.16v652.8c0 51.2 43.52 92.16 97.28 92.16h532.48c53.76 0 97.28-40.96 97.28-92.16V279.04c0-51.2-43.52-92.16-97.28-92.16z m0 744.96H343.04V279.04h532.48v652.8z"  ></path></symbol></svg>';var script = function () {
    var scripts = document.getElementsByTagName("script");return scripts[scripts.length - 1];
  }();var shouldInjectCss = script.getAttribute("data-injectcss");var ready = function ready(fn) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) {
        setTimeout(fn, 0);
      } else {
        var loadFn = function loadFn() {
          document.removeEventListener("DOMContentLoaded", loadFn, false);fn();
        };document.addEventListener("DOMContentLoaded", loadFn, false);
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn);
    }function IEContentLoaded(w, fn) {
      var d = w.document,
          done = false,
          init = function init() {
        if (!done) {
          done = true;fn();
        }
      };var polling = function polling() {
        try {
          d.documentElement.doScroll("left");
        } catch (e) {
          setTimeout(polling, 50);return;
        }init();
      };polling();d.onreadystatechange = function () {
        if (d.readyState == "complete") {
          d.onreadystatechange = null;init();
        }
      };
    }
  };var before = function before(el, target) {
    target.parentNode.insertBefore(el, target);
  };var prepend = function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  };function appendSvg() {
    var div, svg;div = document.createElement("div");div.innerHTML = svgSprite;svgSprite = null;svg = div.getElementsByTagName("svg")[0];if (svg) {
      svg.setAttribute("aria-hidden", "true");svg.style.position = "absolute";svg.style.width = 0;svg.style.height = 0;svg.style.overflow = "hidden";prepend(svg, document.body);
    }
  }if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (e) {
      console && console.log(e);
    }
  }ready(appendSvg);
})(window);

/***/ }),

/***/ "h2zT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ogId":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-loading"
  }, [_c('div', {
    staticClass: "v-line v-line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-line v-line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-line v-line3"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-line v-line4"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-line v-line5"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_create_vue__ = __webpack_require__("AFlf");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    create: __WEBPACK_IMPORTED_MODULE_0__components_create_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "zMSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-create-wrap"
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "item title",
    class: {
      'title-focus': _vm.focusIndex === 'title'
    },
    on: {
      "click": function($event) {
        _vm.focusTitle($event)
      }
    }
  }, [_c('div', {
    staticClass: "li"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.display_name),
      expression: "data.display_name"
    }],
    staticClass: "form-title",
    attrs: {
      "placeholder": "表单标题"
    },
    domProps: {
      "value": (_vm.data.display_name)
    },
    on: {
      "focus": function($event) {
        _vm.$autoText($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.data.display_name = $event.target.value
      }, function($event) {
        _vm.$autoText($event)
      }]
    }
  })]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card",
      "editable": ""
    },
    on: {
      "edit": _vm.handleTabsEdit
    },
    model: {
      value: (_vm.tabLang),
      callback: function($$v) {
        _vm.tabLang = $$v
      },
      expression: "tabLang"
    }
  }, _vm._l((_vm.editableTabs), function(item) {
    return _c('el-tab-pane', {
      key: item,
      attrs: {
        "label": item,
        "name": item
      }
    })
  })), _vm._v(" "), _vm._l((_vm.data.name), function(i) {
    return (i.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
      staticClass: "li"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (i.questionnaire_name),
        expression: "i.questionnaire_name"
      }],
      staticClass: "title-area",
      attrs: {
        "placeholder": "问卷标题"
      },
      domProps: {
        "value": (i.questionnaire_name)
      },
      on: {
        "focus": function($event) {
          _vm.$autoText($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          i.questionnaire_name = $event.target.value
        }, function($event) {
          _vm.$autoText($event)
        }]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.name), function(i) {
    return (i.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
      staticClass: "li"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (i.desc),
        expression: "i.desc"
      }],
      attrs: {
        "placeholder": "问卷说明"
      },
      domProps: {
        "value": (i.desc)
      },
      on: {
        "focus": function($event) {
          _vm.$autoText($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          i.desc = $event.target.value
        }, function($event) {
          _vm.$autoText($event)
        }]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_c('span', [_vm._v("允许重复提交")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "width": 40,
      "on-color": "#4ca2ae",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.data.repeat_submit),
      callback: function($$v) {
        _vm.data.repeat_submit = $$v
      },
      expression: "data.repeat_submit"
    }
  })], 1), _vm._v(" "), (!_vm.data.question.length) ? _c('div', {
    staticClass: "add-list",
    on: {
      "click": _vm.addListFn
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "q-wrap"
  }, _vm._l((_vm.data.question), function(data, index) {
    return _c('draggable', {
      key: index,
      attrs: {
        "options": {
          group: 'people'
        },
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": _vm.onEnd
      },
      model: {
        value: (data.question),
        callback: function($$v) {
          data.question = $$v
        },
        expression: "data.question"
      }
    }, [_c('div', {
      staticClass: "q-li",
      class: {
        'q-li-focus': _vm.focusIndex === index
      },
      attrs: {
        "id": "items"
      },
      on: {
        "click": function($event) {
          _vm.focusItem($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "drap-area"
    }, [_c('i', {
      staticClass: "iconfont icon-tuozhuai"
    })]), _vm._v(" "), _vm._l((data.content), function(content, index1) {
      return (content.language === _vm.langCode[_vm.langList.indexOf(_vm.tabLang)]) ? _c('div', {
        staticClass: "q-item-wrap"
      }, [_c('div', {
        staticClass: "q-item q-title-wrap"
      }, [_c('div', {
        staticClass: "q-title"
      }, [_c('div', {
        staticClass: "li"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.title),
          expression: "content.title"
        }],
        staticClass: "q-area",
        attrs: {
          "placeholder": "问题"
        },
        domProps: {
          "value": (content.title)
        },
        on: {
          "focus": function($event) {
            _vm.$autoText($event)
          },
          "input": [function($event) {
            if ($event.target.composing) { return; }
            content.title = $event.target.value
          }, function($event) {
            _vm.$autoText($event)
          }]
        }
      })])]), _vm._v(" "), (_vm.focusIndex === index) ? _c('el-select', {
        staticClass: "q-select",
        attrs: {
          "filterable": "",
          "placeholder": "请选择"
        },
        model: {
          value: (data.types),
          callback: function($$v) {
            data.types = $$v
          },
          expression: "data.types"
        }
      }, _vm._l((_vm.selectOptions), function(item) {
        return _c('el-option', {
          key: item,
          attrs: {
            "label": item,
            "value": item
          }
        })
      })) : _vm._e()], 1), _vm._v(" "), (data.types === '下拉列表' || data.types === '单选题' || data.types === '多选题' || data.types === '优先级') ? _c('div', {
        staticClass: "q-item"
      }, [_vm._l((content.answer), function(item, i) {
        return _c('div', {
          staticClass: "q-radio"
        }, [(data.types === '下拉列表' || data.types === '优先级') ? _c('div', {
          staticClass: "icon-radio"
        }, [_vm._v(_vm._s(i + 1) + ".")]) : _c('div', {
          staticClass: "icon-radio",
          class: {
            'icon-cirle': data.types === '单选题', 'icon-square': data.types === '多选题'
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.description),
            expression: "item.description"
          }],
          staticClass: "radio-input",
          domProps: {
            "value": (item.description)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.description = $event.target.value
            }
          }
        }), _vm._v(" "), (_vm.focusIndex === index) ? _c('i', {
          staticClass: "el-icon-close",
          on: {
            "click": function($event) {
              _vm.deleteRadioFn(index, index1, i)
            }
          }
        }) : _vm._e()])
      }), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-radio"
      }, [(data.types === '下拉列表' || data.types === '优先级') ? _c('div', {
        staticClass: "icon-radio"
      }, [_vm._v(_vm._s(content.answer.length + 1) + ".")]) : _c('div', {
        staticClass: "icon-radio",
        class: {
          'icon-cirle': data.types === '单选题', 'icon-square': data.types === '多选题'
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.addRadio),
          expression: "addRadio"
        }],
        staticClass: "radio-add",
        domProps: {
          "value": (_vm.addRadio)
        },
        on: {
          "focus": function($event) {
            _vm.addRadioFn(index, index1)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.addRadio = $event.target.value
          }
        }
      })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (data.types === '线性量表') ? _c('div', {
        staticClass: "q-item line-wrap"
      }, [_c('div', {
        staticClass: "q-item-line"
      }, [_c('el-select', {
        model: {
          value: (content.line_answer.line_value),
          callback: function($$v) {
            content.line_answer.line_value = $$v
          },
          expression: "content.line_answer.line_value"
        }
      }, _vm._l((_vm.lineOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      })), _vm._v(" "), _c('span', {
        staticClass: "line-tip"
      }, [_vm._v("到")]), _vm._v(" "), _c('el-select', {
        model: {
          value: (content.line_answer.line_end_value),
          callback: function($$v) {
            content.line_answer.line_end_value = $$v
          },
          expression: "content.line_answer.line_end_value"
        }
      }, _vm._l((_vm.lineEndOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      }))], 1), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("1.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_tag),
          expression: "content.line_answer.line_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_tag = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("2.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_end_tag),
          expression: "content.line_answer.line_end_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_end_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_end_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (data.types === '文本题') ? _c('div', {
        staticClass: "q-item text-wrap"
      }, [_vm._v("文本回答")]) : _vm._e(), _vm._v(" "), (data.types === '矩阵量表') ? _c('div', {
        staticClass: "q-item line-wrap square-wrap"
      }, [_c('div', {
        staticClass: "square-li"
      }, [_c('h4', [_vm._v("行")]), _vm._v(" "), _c('div', {
        staticClass: "q-item-line"
      }, [_c('el-select', {
        model: {
          value: (content.line_answer.line_value),
          callback: function($$v) {
            content.line_answer.line_value = $$v
          },
          expression: "content.line_answer.line_value"
        }
      }, _vm._l((_vm.lineOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      })), _vm._v(" "), _c('span', {
        staticClass: "line-tip"
      }, [_vm._v("到")]), _vm._v(" "), _c('el-select', {
        model: {
          value: (content.line_answer.line_end_value),
          callback: function($$v) {
            content.line_answer.line_end_value = $$v
          },
          expression: "content.line_answer.line_end_value"
        }
      }, _vm._l((_vm.lineEndOptions), function(i) {
        return _c('el-option', {
          key: i,
          attrs: {
            "value": i
          }
        })
      }))], 1), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("1.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_tag),
          expression: "content.line_answer.line_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_tag = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v("2.")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (content.line_answer.line_end_tag),
          expression: "content.line_answer.line_end_tag"
        }],
        staticClass: "radio-input",
        attrs: {
          "placeholder": "标签（选填）"
        },
        domProps: {
          "value": (content.line_answer.line_end_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            content.line_answer.line_end_tag = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "square-li"
      }, [_c('h4', [_vm._v("列")]), _vm._v(" "), _vm._l((content.answer), function(item, i) {
        return _c('div', {
          staticClass: "q-radio"
        }, [_c('div', {
          staticClass: "icon-radio"
        }, [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.description),
            expression: "item.description"
          }],
          staticClass: "radio-input",
          domProps: {
            "value": (item.description)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              item.description = $event.target.value
            }
          }
        }), _vm._v(" "), (_vm.focusIndex === index) ? _c('i', {
          staticClass: "el-icon-close",
          on: {
            "click": function($event) {
              _vm.deleteRadioFn(index, index1, i)
            }
          }
        }) : _vm._e()])
      }), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-radio"
      }, [_c('div', {
        staticClass: "icon-radio"
      }, [_vm._v(_vm._s(content.answer.length + 1) + ".")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.addRadio),
          expression: "addRadio"
        }],
        staticClass: "radio-add",
        domProps: {
          "value": (_vm.addRadio)
        },
        on: {
          "focus": function($event) {
            _vm.addRadioFn(index, index1)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.addRadio = $event.target.value
          }
        }
      })]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.focusIndex === index) ? _c('div', {
        staticClass: "q-item option-wrap"
      }, [_c('ul', {
        staticClass: "option-list"
      }, [_c('li', [_c('i', {
        staticClass: "iconfont icon-copy",
        on: {
          "click": function($event) {
            _vm.copyListFn(index)
          }
        }
      })]), _vm._v(" "), _c('li', [_c('i', {
        staticClass: "el-icon-delete",
        on: {
          "click": function($event) {
            _vm.deleteListFn(index)
          }
        }
      })]), _vm._v(" "), _c('li', [_c('span', [_vm._v("必填")]), _vm._v(" "), _c('el-switch', {
        attrs: {
          "width": 40,
          "on-color": "#4ca2ae",
          "on-text": "",
          "off-text": ""
        },
        model: {
          value: (data.is_required),
          callback: function($$v) {
            data.is_required = $$v
          },
          expression: "data.is_required"
        }
      })], 1)])]) : _vm._e()]) : _vm._e()
    })], 2)])
  }))]), _vm._v(" "), (_vm.data.question.length) ? _c('div', {
    staticClass: "form-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-li",
    on: {
      "click": _vm.addListFn
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "form-save",
    on: {
      "click": _vm.saveFn
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "add-lang",
    attrs: {
      "title": "添加语言",
      "visible": _vm.addLangVisible,
      "close-on-click-modal": false,
      "top": "34%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addLangVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "li-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("选择语言")]), _vm._v(" "), _c('el-select', {
    staticClass: "q-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.defaultLang),
      callback: function($$v) {
        _vm.defaultLang = $$v
      },
      expression: "defaultLang"
    }
  }, _vm._l((_vm.langList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addLangVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLangFn
    }
  }, [_vm._v("确 定")])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5e75857ce9721ff09e90.js